import { createContext } from 'react';
export var FRContext = /*#__PURE__*/createContext(null);
export var ConfigContext = /*#__PURE__*/createContext(null);